/**
 * VerifyEmail: consumes the ?token= link from the verification email.
 */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../lib/auth';
import { AuthShell } from '../components/AuthShell';

export function VerifyEmail(): JSX.Element {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [state, setState] = useState<'working' | 'done' | 'error'>('working');

  useEffect(() => {
    let cancelled = false;
    if (!token) {
      setState('error');
      return;
    }
    verifyEmail(token)
      .then(() => {
        if (!cancelled) setState('done');
      })
      .catch(() => {
        if (!cancelled) setState('error');
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <AuthShell title={t('auth.verifyTitle')}>
      {state === 'working' && <p className="text-sm text-stone-600">{t('auth.verifying')}</p>}
      {state === 'done' && (
        <div>
          <p role="status" className="text-sm text-stone-700">
            {t('auth.verified')}
          </p>
          <Link
            to="/signin"
            className="mt-4 inline-block rounded-lg bg-tenant-primary px-4 py-2 text-sm font-medium text-white hover:bg-tenant-strong"
          >
            {t('auth.signInToContinue')}
          </Link>
        </div>
      )}
      {state === 'error' && (
        <div>
          <p role="alert" className="text-sm text-red-600">
            {t('auth.verifyInvalid')}
          </p>
          <Link
            to="/signup"
            className="mt-4 inline-block rounded-lg bg-tenant-primary px-4 py-2 text-sm font-medium text-white hover:bg-tenant-strong"
          >
            {t('auth.backToSignUp')}
          </Link>
        </div>
      )}
    </AuthShell>
  );
}
